/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import AntParagraph from 'antd/es/typography/Paragraph';

const fontSizes = {
  lg: '16px',
};

const Paragraph = ({ children, align, size, noBottomMargin, style, ...props }) => {
  const customStyle = {
    textAlign: align,
    marginBottom: noBottomMargin ? 0 : undefined,
    fontSize: fontSizes[size],
    ...style,
  };

  return (
    <AntParagraph style={customStyle} {...props}>
      {children}
    </AntParagraph>
  );
};

Paragraph.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  align: PropTypes.oneOf(['center', 'left', 'right', 'justify']),
  size: PropTypes.oneOf(['lg']),
  noBottomMargin: PropTypes.bool,
};

Paragraph.defaultProps = {
  align: undefined,
  style: undefined,
  size: undefined,
  noBottomMargin: undefined,
};

export default Paragraph;
